import React, { useEffect, useState } from "react";
import { Icon, Loader, Message } from "semantic-ui-react";

import { toolTipManager } from "../../services/instanceService";

import "./tool_tip.css";

const ToolTipList = ({ onOpenVideo }) => {
  const [tips, setTips] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadTips = async () => {
      setLoading(true);
      try {
        await toolTipManager.init();
        setTips(toolTipManager.getAll());
      } catch (err) {
        console.error("Failed to load tool tips:", err);
        setError("Could not load tool tips. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    loadTips();
  }, []);

  const toggleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const getToggleClass = (id) => {
    return `tooltip-list-toggle ${expandedId === id ? "expanded" : ""}`;
  };

  const getToggleIconName = (id) => {
    return expandedId === id ? "angle down" : "angle right";
  };

  const renderContent = () => {
    if (loading) {
      return <Loader active inline="centered" />;
    }
    if (error) {
      return <Message negative header="Error" content={error} />;
    }
    if (tips.length === 0) {
      return <Message info content="No tool tips are available." />;
    }
    return tips.map((tip) => (
      <div key={tip.id} className="tooltip-list-item">
        <button
          type="button"
          className={`btn-reset ${getToggleClass(tip.id)}`}
          onClick={() => toggleExpand(tip.id)}
          aria-expanded={expandedId === tip.id}
        >
          <Icon
            name={getToggleIconName(tip.id)}
            className="tooltip-toggle-icon"
          />
          {tip.title}
        </button>
        {expandedId === tip.id && (
          <div className="tooltip-list-details">
            <div className="tooltip-list-item-header">
              <strong className="tooltip-list-item-title">{tip.title}</strong>
              {tip.video_link && (
                <button
                  className="tooltip-video-button"
                  onClick={() => onOpenVideo(tip.video_link, tip.title, true)}
                >
                  Watch Video
                </button>
              )}
            </div>
            <div className="tooltip-list-description">
              {(tip.description || "").split("\n").map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
    ));
  };

  return (
    <React.Fragment>
      <div className="tooltip-list">
        <h2 className="tooltip-list-title">Tool Tips</h2>
        {renderContent()}
      </div>
    </React.Fragment>
  );
};

export default ToolTipList;


// WEBPACK FOOTER //
// ./src/components/tool_tips/tool_tip_list.js